
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_5613_21980)"}},[_c('path',{attrs:{"d":"M4.90717 13.3333H1.66634C1.44533 13.3333 1.23337 13.2455 1.07709 13.0893C0.920805 12.933 0.833008 12.721 0.833008 12.5V7.5C0.833008 7.27898 0.920805 7.06702 1.07709 6.91074C1.23337 6.75446 1.44533 6.66666 1.66634 6.66666H4.90717L9.31884 3.05666C9.37988 3.00662 9.45388 2.97494 9.53223 2.96533C9.61058 2.95571 9.69004 2.96854 9.76138 3.00233C9.83271 3.03612 9.89298 3.08948 9.93517 3.15619C9.97736 3.22291 9.99973 3.30023 9.99967 3.37916V16.6208C9.99973 16.6998 9.97736 16.7771 9.93517 16.8438C9.89298 16.9105 9.83271 16.9639 9.76138 16.9977C9.69004 17.0315 9.61058 17.0443 9.53223 17.0347C9.45388 17.025 9.37988 16.9934 9.31884 16.9433L4.90801 13.3333H4.90717ZM16.1713 16.7783L14.9913 15.5983C15.7813 14.8954 16.4133 14.0331 16.8457 13.0681C17.278 12.1031 17.5009 11.0574 17.4997 10C17.5007 8.88841 17.2541 7.79054 16.7779 6.78614C16.3016 5.78174 15.6076 4.89603 14.7463 4.19333L15.9297 3.01C16.9451 3.86962 17.7607 4.9404 18.3197 6.14766C18.8787 7.35492 19.1677 8.66959 19.1663 10C19.1663 12.6858 18.0113 15.1017 16.1713 16.7783ZM13.2188 13.8258L12.0338 12.6408C12.4384 12.3297 12.766 11.9298 12.9913 11.4719C13.2165 11.0139 13.3335 10.5103 13.333 10C13.333 8.80833 12.708 7.7625 11.7663 7.17333L12.9655 5.97416C13.5967 6.43849 14.1098 7.04487 14.4632 7.74426C14.8165 8.44365 15.0003 9.2164 14.9997 10C14.9997 11.535 14.308 12.9083 13.2188 13.8258Z","fill":"currentColor"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_5613_21980"}},[_c('rect',{attrs:{"width":"20","height":"20","fill":"currentColor"}})])])])
          )
        }
      }
    